import React, { useEffect, useState } from "react";
import Logo from "./Logo";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Partners", href: "#partners" },
  { label: "Frameworks", href: "#frameworks" },
  { label: "Innovation", href: "#innovation" },
  { label: "Activities", href: "#activities" },
  { label: "Trainings", href: "#trainings" },
  { label: "SUSI", href: "#susi" },
  { label: "Books", href: "#books" },
  { label: "Events", href: "#events" },
  { label: "Gallery", href: "#gallery" },
  { label: "Insights", href: "#blog" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-ivory/85 border-b border-ink-10"
          : "bg-transparent"
      }`}
      style={{ borderColor: "rgba(11,31,56,0.12)" }}
    >
      <div className="container-prose flex items-center justify-between h-16 sm:h-20">
        <Logo />
        <nav className="hidden lg:flex items-center gap-5 xl:gap-7 ml-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-[12px] xl:text-[13px] tracking-wide whitespace-nowrap text-ink/80 hover:text-forest transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          data-testid="nav-contact-cta"
          className="hidden lg:inline-flex items-center gap-2 px-4 py-2.5 text-[11px] xl:text-[12px] uppercase tracking-[0.18em] font-medium whitespace-nowrap border border-ink/30 hover:bg-ink hover:text-ivory transition-all"
        >
          Book Karamjeet
        </a>
        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 -mr-2 text-ink"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-ink-10 bg-ivory/95 backdrop-blur-xl"
        >
          <div className="container-prose py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-base text-ink/80 hover:text-forest"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center px-5 py-3 text-[12px] uppercase tracking-[0.2em] font-medium border border-ink/30"
            >
              Book Karamjeet
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
